import { IToDoItem } from './models';

interface IProps {
    item: IToDoItem
}

const ToDoItem = ({ item }: IProps) => (
    <button type='button' className='ac-item' disabled={item.count == 0 || item.onClick == null} onClick={item.onClick}>
        <span className='ac-pill'>{item.count}</span>
        <span className='ac-item-label'>{item.label}</span>
    </button>
);

export default ToDoItem;
